import { Tree } from 'antd';
import * as React from 'react';

import buildTree from '../../../../helpers/tree';

export interface ICategoriesSelectProps {
  categories: Array<GQL.ICategory>;
  selectedCategories: Array<GQL.ICategory>;
  onChange: (checkedKeys: Array<string>) => void;
}

export default class CategoriesSelect extends React.Component<ICategoriesSelectProps, any> {

  private treeData: any;

  constructor(props: ICategoriesSelectProps) {
    super(props);

    this.treeData = buildTree(
      props.categories.map(c => {
        return {
          ...c,
          parentId: (c.parentCategory || ({} as GQL.ICategory)).id
        };
      }),
      'parentId',
      'id'
    );
  }
  
  
  public render() {
    const { selectedCategories } = this.props;
    
    return (
      <div>
        <Tree
          onCheck={(checkedKeys: any) => this.props.onChange(checkedKeys)}
          onSelect={(checkedKeys: any) => this.props.onChange(checkedKeys)}
          multiple={true}
          checkable={true}
          checkStrictly={true}
          showLine={true}
          defaultExpandAll={false}
          selectedKeys={(selectedCategories || []).map(category => category.id.toString())}
          checkedKeys={(selectedCategories || []).map(category => category.id.toString())}
          treeData={this.treeData}
          />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/GeneralSettingsTab/CategoriesSelect.tsx